module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-5.14b4ce9d.png";